import { Component, Input } from "@angular/core";
import { ProductPlansConfiguration } from "../models/product-plans-config-model";

@Component({
    selector: 'app-product-plans',
    templateUrl: './templates/productPlans.component.html'
})
export class ProductPlansComponent {
    @Input()
    config!: ProductPlansConfiguration;
}